<template>
  <div>
    <div
      style="display: flex; width: 100%; justify-content: center; color: #fff; position: absolute"
      :style="{ top: radioTop }"
      v-if="radioStatu"
    >
      <a-radio-group :value="current" :defaultValue="defaultValue" @change="changeRadios">
        <template v-for="(item, index) in radioList">
          <a-radio :value="item.value">{{ item.label }}</a-radio>
        </template>
      </a-radio-group>
      <slot name="radio"></slot>
    </div>
    <div v-if="siteType == 1">
      <div
        v-if="localSiteWarnList.length > 0"
        :title="localSiteWarnList.length > minSum ? (moveState ? '双击播放' : '双击停止') : ''"
        @dblclick="toggleState()"
      >
        <div class="main_table t_btn2 scroll-box" :style="{ height: 'auto', marginTop: marginTop || '33px' }">
          <table>
            <thead>
              <tr>
                <th>站点</th>
                <th>报警内容</th>
                <th>报警时间</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="main_table t_btn2 scroll-box" :style="{ height: height, marginTop: '0', overflow: overflow }">
          <table>
            <tbody>
              <tr v-for="(item, index) in localSiteWarnList" :key="'A' + index">
                <td @click="onToJump(item)"><a style="color: #00d6ff">{{ item.siteName }}</a></td>
                <td>{{ item.warnContent }}</td>
                <td>{{ item.warnTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: 20px">
        <div style="dispalt: flex; flex-direction: column">
          <div>
            <img style="width: 150px; height: 100px; margin-top: 10px" src="../../../public/zanwushuju.png" alt="" />
          </div>
          <div style="font-size: 25px; margin-top: 20px; width: 150px; text-align: center; color: #cdcdcd">
            <span style="">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="siteType == 2">
      <div
        v-if="localSiteWarnList.length > 0"
        :title="localSiteWarnList.length > minSum ? (moveState ? '双击播放' : '双击停止') : ''"
        @dblclick="toggleState()"
      >
        <div class="main_table t_btn2 scroll-box" :style="{ height: 'auto', marginTop: marginTop || '33px' }">
          <table>
            <thead>
              <tr style="display: flex">
                <th>站点</th>
                <th style="display: flex; justify-content: center; width: 40%" @click="onSortStandard('standard')">
                  水质标准
                  <div style="margin-left: 5px; margin-top: -5px" v-if="sortState">
                    <div
                      class="iconfont icon-shang"
                      style="font-size: 15px"
                      :style="[{ color: SortStandardState === true ? '' : '#ccc' }]"
                    ></div>
                    <div
                      class="iconfont icon-sortdown"
                      style="font-size: 13px; margin-top: -10px"
                      :style="[{ color: SortStandardState === false ? '' : '#ccc' }]"
                    ></div>
                  </div>
                </th>
                <th style="display: flex; justify-content: center; width: 40%" @click="onSortTime('time')">
                  监测时间
                  <div style="margin-left: 5px; margin-top: -5px" v-if="sortState">
                    <div
                      class="iconfont icon-shang"
                      style="font-size: 15px"
                      :style="[{ color: SortTimeState === true ? '' : '#ccc' }]"
                    ></div>
                    <div
                      class="iconfont icon-sortdown"
                      style="font-size: 13px; margin-top: -10px"
                      :style="[{ color: SortTimeState === false ? '' : '#ccc' }]"
                    ></div>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="main_table t_btn2 scroll-box" :style="{ height: height, marginTop: '0', overflow: overflow }">
          <table>
            <tbody>
              <tr v-for="(item, index) in localSiteWarnList" :key="'B' + index">
                <td :style="[{ color: item.attrs.siteOnline ? '#3bb300' : '' }]">{{ item.attrs.siteName }}</td>
                <td
                  style="display: flex; align-items: center; height: 4.2vh; justify-content: space-around; width: auto"
                >
                  <div style="flex: 1.2; display: flex; justify-content: center; margin-left: 20px">
                    <div
                      :style="{
                        backgroundColor:
                          item.attrs.currentStandard && item.attrs.currentStandard.color
                            ? item.attrs.currentStandard.color
                            : '',
                      }"
                      style="padding: 0 5px; border-radius: 5px; margin-right: 10px; line-height: 20px; color: #000"
                    >
                      {{
                        item.attrs.currentStandard && item.attrs.currentStandard.title
                          ? item.attrs.currentStandard.title
                          : ''
                      }}
                    </div>
                  </div>
                  <div style="flex: 1; margin-right: 15px">
                    {{
                      item.attrs.currentStandard && item.attrs.currentStandard.alias
                        ? item.attrs.currentStandard.alias
                        : ''
                    }}
                  </div>
                </td>
                <td>{{ item.dataTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: 20px">
        <div style="dispalt: flex; flex-direction: column">
          <div>
            <img style="width: 150px; height: 100px; margin-top: 10px" src="../../../public/zanwushuju.png" alt="" />
          </div>
          <div style="font-size: 25px; margin-top: 20px; width: 150px; text-align: center; color: #cdcdcd">
            <span style="">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="siteType == 3">
      <div
        v-if="localSiteWarnList.length > 0"
        :title="localSiteWarnList.length > minSum ? (moveState ? '双击播放' : '双击停止') : ''"
        @dblclick="toggleState()"
      >
        <div class="main_table t_btn2 scroll-box" :style="{ height: 'auto', marginTop: marginTop || '33px' }">
          <table>
            <thead>
              <tr>
                <th style="width: 25%">报警类型</th>
                <th>报警内容</th>
                <th>监测时间</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="main_table t_btn2 scroll-box" :style="{ height: height, marginTop: '0', overflow: overflow }">
          <table>
            <tbody>
              <tr v-for="(item, index) in localSiteWarnList" :key="'C' + index">
                <td style="width: 25%" @click="onToJump(item)"><a style="color: #00d6ff">{{ item.category_dictText }}</a></td>
                <td>{{ item.warnContent }}</td>
                <td>{{ item.warnTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: 20px">
        <div style="dispalt: flex; flex-direction: column">
          <div>
            <img style="width: 150px; height: 100px; margin-top: 10px" src="../../../public/zanwushuju.png" alt="" />
          </div>
          <div style="font-size: 25px; margin-top: 20px; width: 150px; text-align: center; color: #cdcdcd">
            <span style="">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="siteType == 4">
      <div
        v-if="localSiteWarnList.length > 0"
        @dblclick="toggleState()"
        :title="localSiteWarnList.length > minSum ? (moveState ? '双击播放' : '双击停止') : ''"
      >
        <div class="main_table t_btn2 scroll-box" :style="{ height: 'auto', marginTop: marginTop || '33px' }">
          <table>
            <thead>
              <tr>
                <th style="width: 25%">排名</th>
                <th>站点</th>
                <th>AQI</th>
                <th>等级</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="main_table t_btn2 scroll-box" :style="{ height: height, marginTop: '0', overflow: overflow }">
          <table>
            <tbody>
              <tr v-for="(item, index) in localSiteWarnList" :key="'D' + index">
                <td style="width: 25%">{{ index + 1 }}</td>
                <td>{{ item.attrs.siteName }}</td>
                <td>{{ item.factor.a99901.value }}</td>
                <td style="width: 100%; display: flex; align-items: center; justify-content: center; height: 40px">
                  <div
                    style="width: 50px; border-radius: 5px; padding: 2px 5px"
                    :style="{ backgroundColor: item.attrs.currentStandard ? item.attrs.currentStandard.color : '' }"
                  >
                    {{ item.attrs.currentStandard ? item.attrs.currentStandard.title : '' }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: 20px">
        <div style="dispalt: flex; flex-direction: column">
          <div>
            <img style="width: 150px; height: 100px; margin-top: 10px" src="../../../public/zanwushuju.png" alt="" />
          </div>
          <div style="font-size: 25px; margin-top: 20px; width: 150px; text-align: center; color: #cdcdcd">
            <span style="">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="siteType == 5">
      <div
        v-if="localSiteWarnList.length > 0"
        @dblclick="toggleState()"
        :title="localSiteWarnList.length > minSum ? (moveState ? '双击播放' : '双击停止') : ''"
      >
        <div class="main_table t_btn2 scroll-box" :style="{ height: 'auto', marginTop: marginTop || '33px' }">
          <table>
            <thead>
              <tr>
                <th>站点</th>
                <th>排放标准</th>
                <th>监测时间</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="main_table t_btn2 scroll-box" :style="{ height: height, marginTop: '0', overflow: overflow }">
          <table>
            <tbody>
              <tr v-for="(item, index) in localSiteWarnList" :key="'E' + index">
                <td>{{ item.attrs.siteName }}</td>
                <td style="display: flex; align-items: center; height: 4.2vh; justify-content: center; width: auto">
                  <div
                    style="width: 20px; height: 20px; border-radius: 50%"
                    :class="[item.attrs.upStandard ? 'green' : 'red']"
                  ></div>
                </td>
                <td style="width: 30%">{{ item.dataTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: 20px">
        <div style="dispalt: flex; flex-direction: column">
          <div>
            <img style="width: 150px; height: 100px; margin-top: 10px" src="../../../public/zanwushuju.png" alt="" />
          </div>
          <div style="font-size: 25px; margin-top: 20px; width: 150px; text-align: center; color: #cdcdcd">
            <span style="">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业信息列表 -->
    <div v-if="siteType == 6">
      <div
        v-if="localSiteWarnList.length > 0"
        @dblclick="toggleState()"
        :title="localSiteWarnList.length > minSum ? (moveState ? '双击播放' : '双击停止') : ''"
      >
        <div class="main_table t_btn2 scroll-box" :style="{ height: 'auto', marginTop: marginTop || '33px' }">
          <table>
            <thead>
              <tr>
                <th>企业名称</th>
                <th>法人</th>
                <th>电话</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="main_table t_btn2 scroll-box" :style="{ height: height, marginTop: '0', overflow: overflow }">
          <table>
            <tbody>
              <tr v-for="(item, index) in localSiteWarnList" :key="'E' + index" @click="onToClickItem(item)">
                <td>{{ item.companyName }}</td>
                <td>{{ item.companyUser }}</td>
                <!-- <td style="display: flex; align-items: center; height: 4.2vh; justify-content: center; width: auto">
                  <div
                    style="width: 20px; height: 20px; border-radius: 50%"
                    :class="[item.attrs.upStandard ? 'green' : 'red']"
                  ></div>
                </td> -->
                <td style="width: 30%">{{ item.companyPhone }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin-top: 20px">
        <div style="dispalt: flex; flex-direction: column">
          <div>
            <img style="width: 150px; height: 100px; margin-top: 10px" src="../../../public/zanwushuju.png" alt="" />
          </div>
          <div style="font-size: 25px; margin-top: 20px; width: 150px; text-align: center; color: #cdcdcd">
            <span style="">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <table v-if="siteType == 1" @dblclick="toggleState()" :title="localSiteWarnList.length>minSum?moveState?'双击播放':'双击停止':''">
			<thead>
				<tr>
					<th>站点</th>
					<th>报警内容</th>
					<th>报警时间</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in localSiteWarnList" :key="index">
					<td>{{ item.siteName }}</td>
					<td>{{ item.warnContent }}</td>
					<td>{{ item.warnTime }}</td>
				</tr>
			</tbody>
		</table> -->
    <!-- <div class="main_table t_btn2 scroll-box" :style="{height:height,marginTop:top,overflow:overflow}"> -->
    <!-- <table v-if="siteType == 2" @dblclick="toggleState()" :title="localSiteWarnList.length>minSum?moveState?'双击播放':'双击停止':''">
				<thead>
					<tr>
						<th>站点</th>
						<th>水质标准</th>
						<th>监测时间</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in localSiteWarnList" :key="index">
						<td>{{ item.attrs.siteName }}</td>
						<td style="display: flex;align-items: center;height:42px;justify-content: center;">
							<div :style="{backgroundColor:item.attrs.currentStandard.color}" style="padding: 0 5px;border-radius: 5px;margin-right: 10px;line-height: 20px;color:#000">{{ item.attrs.currentStandard.title}}</div>{{ item.attrs.currentStandard.alias}}
						</td>
						<td>{{ item.dataTime }}</td>
					</tr>
				</tbody>
			</table> -->
    <!-- <table v-if="siteType == 3" @dblclick="toggleState()" :title="localSiteWarnList.length>minSum?moveState?'双击播放':'双击停止':''">
				<thead>
					<tr>
						<th>报警类型</th>
						<th>报警内容</th>
						<th>监测时间</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in localSiteWarnList" :key="index">
						<td>{{ item.category_dictText }}</td>
						<td>{{ item.warnContent }}</td>
						<td>{{ item.warnTime }}</td>
					</tr>
				</tbody>
			</table> -->
    <!-- <table v-if="siteType == 4" @dblclick="toggleState()" :title="localSiteWarnList.length>minSum?moveState?'双击播放':'双击停止':''">
				<thead>
					<tr>
						<th>排名</th>
						<th>站点</th>
						<th>AQI</th>
						<th>等级</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in localSiteWarnList" :key="index">
						<td>{{ index+1 }}</td>
						<td>{{ item.attrs.siteName }}</td>
						<td>{{ item.factor.a99901.value }}</td>
						<td style="display: flex;align-items: center;width: 100%;justify-content: center;height: 40px;">
							<div style="width: 50px;border-radius: 5px;padding:2px 5px;" :style="{backgroundColor:(item.attrs.currentStandard?item.attrs.currentStandard.color:'')}">{{ item.attrs.currentStandard?item.attrs.currentStandard.title:'' }}</div>
						</td>
					</tr>
				</tbody>
			</table> -->
    <!-- <table v-if="siteType == 5" @dblclick="toggleState()" :title="localSiteWarnList.length>minSum?moveState?'双击播放':'双击停止':''">
				<thead>
					<tr>
						<th>站点</th>
						<th>排放标准</th>
						<th>监测时间</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in localSiteWarnList" :key="index">
						<td>{{ item.attrs.siteName }}</td>
						<td style="width: 100%;height: 58px;display: flex;align-items: center;justify-content: center;">
							<div style="width: 20px;height: 20px;border-radius: 50%;" :class="[item.attrs.upStandard?'green':'red']"></div>
						</td>
						<td>{{ item.dataTime }}</td>
					</tr>
				</tbody>
			</table> -->
    <!-- </div> -->
    <warn-data-modal ref="warnDataModalRef"></warn-data-modal>
  </div>
</template>
<script>
import warnDataModal from '@/views/online/component/warnDataModal'
import { getAction } from '@/api/manage'
export default {
  props: {
    radioList: {
      type: Array,
      default: () => [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '数据报警',
          value: 1,
        },
        {
          label: '设备报警',
          value: 2,
        },
        {
          label: '离线报警',
          value: 4,
        },
      ],
    },
    siteWarnList: {
      type: Array,
      default: () => [],
    },
    siteType: {
      type: String,
      defult: 1,
    },
    height: {
      type: String,
      default: '252px',
    },
    top: {
      type: String,
      default: '30px',
    },
    defaultValue: {
      type: Number,
      default: 0,
    },
    current: {
      type: Number,
      default: 0,
    },
    radioStatu: {
      type: Boolean,
      default: false,
    },
    radioTop: {
      type: String,
      default: '22px',
    },
    minSum: {
      type: String,
      default: '0',
    },
    sortState: {
      type: Boolean,
      default: false,
    },
    marginTop: {},
  },
  components:{
    warnDataModal
  },
  data() {
    return {
      moveState: false,
      overflow: 'hidden',
      SortStandardState: '',
      SortTimeState: '',
      localSiteWarnList : [],
    }
  },
  mounted() {
    console.log('mounted')
    // this.init()
  },
  watch: {
    moveState(value) {
      if (value) {
        this.overflow = 'auto'
      } else {
        this.overflow = 'hidden'
      }
    },
    siteWarnList: {
      handler(newVal) {
        // 永春暂时注释掉报警数据的显示
        if(window.localStorage.getItem('projectCode') == 'yongchun' && (this.siteType == 1 || this.siteType == 3)) {
          this.localSiteWarnList = []
          return
        }
        this.localSiteWarnList = JSON.parse(JSON.stringify(newVal))
        this.init()
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() {
    clearInterval(this.Inter)
  },
  methods: {
    onToClickItem(item){
      console.log('onToClickItem', item)
      this.$emit('onToClickItem', item)
    },
    onToJump(data){
      console.log('onToJump',data)
      switch (data.category) {
        case '1':  //数据异常部分
          // this.modalObj.title = `${data.siteName}(${data.warnContent})`
          // this.modalObj.dataSource = [data]
          // this.modalObj.expandedRowKeys = [data.id]
          // this.modalObj.visible = true
          // this.columns = []
          // this.dataSource = []
          // if (data.msgId) {
          //   this.url = `/online/st${data.st}/cn2061`
          //   this.modalObj.st = data.st
          //   this.queryParam = { msgId: data.msgId, scopeId: data.siteId,scope:1 }
          //   this.getCol(data.st)
          //   this.loadData()
          // }

          this.$refs.warnDataModalRef.onToChangeData(data)
          break
      }
    },
    onSortStandard(sortData) {
      this.SortStandardState = !this.SortStandardState
      console.log(this.SortStandardState)
      this.$emit('changeList', this.SortStandardState, sortData)
    },
    onSortTime(sortData) {
      this.SortTimeState = !this.SortTimeState
      this.$emit('changeList', this.SortTimeState, sortData)
    },
    init() {
      clearInterval(this.Inter)
      let data = JSON.parse(JSON.stringify(this.localSiteWarnList))
        this.localSiteWarnList = []
        setTimeout(() => {
          this.localSiteWarnList = data
      clearInterval(this.Inter)

          this.Inter = setInterval(() => {
        setTimeout(() => {
          if (this.localSiteWarnList.length > this.minSum) {
            this.localSiteWarnList.push(this.localSiteWarnList[0]) // 将数组的第一个元素添加到数组的
            this.localSiteWarnList.shift() //删除数组的第一个元素
          }
        }, 500)
      }, 1000)
        }, 500)
      
    },
    changeRadios(e) {
      this.$emit('changetadios', e.target.value)
    },
    toggleState() {
      console.log('123')
      this.moveState = !this.moveState
      if (this.moveState) {
        clearInterval(this.Inter)
      } else {
        
        setTimeout(() => {
          this.init()
          // this.Inter = setInterval(() => {
          //   setTimeout(() => {
          //     if (this.localSiteWarnList.length > this.minSum) {
          //       this.localSiteWarnList.push(this.localSiteWarnList[0]) // 将数组的第一个元素添加到数组的
          //       this.localSiteWarnList.shift() //删除数组的第一个元素
          //     }
          //   }, 500)
          // }, 1000)
        }, 10)
      }
    },
  },
}
</script>
<style scoped>
.ant-radio-wrapper {
  color: #fff !important;
}

/* 报警部分内容 */
.scroll-box {
  height: 252px;
  /* overflow: hidden; */
  /* overflow-y: auto !important; */
}

.main_table tr {
  height: 4.2vh;
}

.main_table {
  width: 100%;
  margin-top: 33px;
}

.main_table table {
  width: 100%;
  animation: name 1s linear;
}

.main_table thead {
  user-select: none;
}

.main_table thead tr {
  height: 4.2vh;
}

.main_table th {
  font-size: 0.8rem;
  font-weight: 600;
  color: #61d2f7;
  text-align: center;
}

.main_table th:nth-child(1),
.main_table td:nth-child(1) {
  width: 35%;
}

.main_table th:nth-child(2),
.main_table td:nth-child(2) {
  width: 35%;
}

.main_table th:nth-child(2),
.main_table td:nth-child(2) {
  width: 30%;
}
.main_table th:nth-child(3),
.main_table td:nth-child(3) {
  width: 30%;
}
.main_table td {
  color: #fff;
  font-size: 12.8px;
  text-align: center;
}

.main_table tbody tr:nth-child(odd) {
  background-color: #072951;
  box-shadow: -10px 0px 15px #034c6a inset, /*左边阴影*/ 10px 0px 15px #034c6a inset;
  /*右边阴影*/
  /*0px 10px 15px #034c6a inset;*/
}

.red {
  background-color: red;
}

.green {
  background-color: green;
}
</style>
